import React from 'react';
import PropTypes from 'prop-types';

import { useIsMobile } from '../../hooks/use-media-query';
import HeaderContainer from '../../containers/HeaderContainer';
import ProjectContainer from '../../containers/ProjectContainer';
import BoardActionsContainer from '../../containers/BoardActionsContainer';

import styles from './Fixed.module.scss';

function Fixed({ projectId, board }) {
  const isMobile = useIsMobile();

  return (
    <div className={styles.wrapper}>
      <HeaderContainer />
      {!isMobile && projectId && <ProjectContainer />}
      {!isMobile && board && !board.isFetching && <BoardActionsContainer />}
      {isMobile && board && !board.isFetching && <BoardActionsContainer showOnlyFilters />}
    </div>
  );
}

Fixed.propTypes = {
  projectId: PropTypes.string,
  board: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

Fixed.defaultProps = {
  projectId: undefined,
  board: undefined,
};

export default Fixed;
